export const environment = {
    production: false,
    envr: 'dev'
};